/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档



export interface API75574Req {
  dataId?: any;
  /** 表头 ,String */
  heads?: string[];
  /** 表数据 ,Map */
  values?: any[];
};



export type API75574Res = {};


// 接口函数 75574 保存模型数据

export interface IUsePostAPI75574Return {
  /** 保存模型数据: 接口请求状态 */
  isAPI75574Loading: boolean;
  /** 保存模型数据: 接口请求返回数据 */
  dataAPI75574: API75574Res;
  /**  保存模型数据: 接口数据请求方法 */
  fetchAPI75574Data: (inputs: API75574Req, config?: YWRequestConfig) => Promise<API75574Res>;
  /** 保存模型数据: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI75574 = ():IUsePostAPI75574Return => {
  let isMount = true;
  const [isAPI75574Loading, setIsAPI75574Loading] = useState(false);
  const [dataAPI75574, setDataAPI75574] = useState<API75574Res>({} as API75574Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/task/model/edit/v2`;

  const fetchAPI75574Data = async (inputs: API75574Req, config?: YWRequestConfig): Promise<API75574Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75574Req>) || {}) as API75574Req;
    
  
    if ( isMount ) {
      setIsAPI75574Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API75574Res>(`${basePath}/yoaichat-web/chat/task/model/edit/v2`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI75574(res || {} as API75574Res);
        setIsAPI75574Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75574Loading(false);
      }
      return false as unknown as API75574Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75574Loading,
    dataAPI75574,
    fetchAPI75574Data,
    requestUrl,
  }
}

